import { format } from 'date-fns';
import { formatMoney } from '../../../../utils/formatters';
/**
 * helper function that returns the useful data from each type of investment, it returns
 * the header of the table and their corresponding value
 * @param investment
 * @returns
 */
export function getInvestmentUsefulDataFromType(investment) {
    var _a, _b;
    var defaultData = [
        { header: 'Code/Descrição', data: investment.name },
        {
            header: 'Balance',
            data: formatMoney(investment.balance, investment.currencyCode),
        },
        {
            header: 'Quantidade da cota',
            data: (_a = investment.quantity) !== null && _a !== void 0 ? _a : '-',
        },
        {
            header: 'Valor da cota',
            data: investment.value !== null
                ? formatMoney(investment.value, investment.currencyCode)
                : '-',
        },
    ];
    if (investment.type === 'FIXED_INCOME') {
        return [
            { header: 'Code/Descrição', data: investment.name },
            {
                header: 'Balance',
                data: formatMoney(investment.balance, investment.currencyCode),
            },
            {
                header: 'Taxa',
                data: investment.rate !== null
                    ? formatMoney(investment.rate, investment.rateType)
                    : '-',
            },
            {
                header: 'Data de vencimento',
                data: investment.dueDate !== null
                    ? format(new Date(investment.dueDate), 'dd/MM/yyyy')
                    : '-',
            },
        ];
    }
    if (investment.type === 'SECURITY') {
        return [
            { header: 'Code/Descrição', data: investment.name },
            {
                header: 'Taxa anual',
                data: investment.annualRate !== null ? investment.annualRate + "%" : '-',
            },
            {
                header: 'Taxa do último mês',
                data: investment.lastMonthRate !== null
                    ? investment.lastMonthRate + "%"
                    : '-',
            },
            {
                header: 'Balance',
                data: formatMoney(investment.balance, investment.currencyCode),
            },
        ];
    }
    if (investment.type === 'MUTUAL_FUND') {
        return [
            { header: 'Code/Descrição', data: investment.name },
            {
                header: 'Taxa anual',
                data: investment.annualRate !== null ? investment.annualRate + "%" : '-',
            },
            {
                header: 'Quantidade da cota',
                data: (_b = investment.quantity) !== null && _b !== void 0 ? _b : '-',
            },
            {
                header: 'Balance',
                data: formatMoney(investment.balance, investment.currencyCode),
            },
        ];
    }
    // type === EQUITY, ETF or another not supported, just show a default
    return defaultData;
}
